import {
    IUser, IUsers,
    UserResponseType,
    IauthUser, IauthUserResponseType, IauthU, IauthUserRoles, UsersResponseType

} from '@/entity/user/user.types'


export class authUser implements IauthUser {
    response:string
    status:boolean
    token:string
    user:IauthU
    constructor(data:IauthUser) {
      this.response = data.response
      this.status = data.status
      this.token = data.token
      this.user = data.user
    }

}

export class Users implements IUsers {
    total: number;
    data: IUser[] = [];
    constructor(data: UsersResponseType) {
        this.total = data.total;
        for (let i = 0; i < data.data.length; i++) {
            this.data.push(data.data[i]);
        }
    }

}

export default class User implements IUser {
    id?: number;
    name: string;
    role_id: number;
    user_type_id: string | null;
    token: string;
    //user_info: any;
    email: string | null;
    phone: string | null;
    //img_path: string | null;
    constructor(data: UserResponseType) {
      this.id = data.id
      this.name = data.name
      this.role_id = data.role_id
      this.user_type_id = data.user_type_id
      this.token = ''
      //this.user_info = data.user_info
      this.email = data.email
      this.phone = data.phone
      //this.img_path = data.img_path
    }
}
